import { forwardRef, type InputHTMLAttributes } from 'react';
import { cn } from '../lib/cn';

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  hasError?: boolean;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, hasError, ...rest }, ref) => (
    <input
      ref={ref}
      className={cn(
        // Explicit text-ink-900 — without it, an Input rendered inside a
        // `text-white` ancestor (e.g. the dark home hero) inherits white
        // text on the white background and the typed value is invisible.
        'flex h-10 w-full rounded border bg-white px-3 py-2 text-sm text-ink-900 transition-colors',
        'placeholder:text-gray-400',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-500 focus-visible:ring-offset-1',
        'disabled:cursor-not-allowed disabled:opacity-50',
        hasError ? 'border-red-500' : 'border-gray-300',
        className,
      )}
      {...rest}
    />
  ),
);
Input.displayName = 'Input';
